import { MediaElement } from 'editor/src/store/design/types';

const containsImageFilters = (media: MediaElement) =>
  media.type === 'image' && (!!media.filters?.length || !!media.adjustments?.filter(({ custom }) => !custom).length);

export default containsImageFilters;
